import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import ProviderOfficeHoursModel from "../../models/provider-office-hours";

export default class ProviderOfficeHoursRepository extends BaseRepository {
  static modelClass = ProviderOfficeHoursModel;
  modelName = "provider-office-hours";

  async bulkCreate(data) {
    return super.post(data, {
      urlPath: `provider_office_hours/bulk_create/`,
    });
  }

  async bulkUpdate(data) {
    return super.post(data, {
      urlPath: `provider_office_hours/bulk_update/`,
    });
  }

  async bulkDelete(data) {
    return super.post(data, {
      urlPath: `provider_office_hours/bulk_delete/`,
    });
  }
}
